import { takeEvery, all, call } from 'redux-saga/effects';
import telematics from 'react/api/actions/telematics';
import tabs from 'react/api/actions/tabs';
import {
  TELEMETICS_DOMAINS,
  getTelematicsStorageDetails
} from 'react/utils/telematicsUtils';

/**
 * schema:
 * {
 *  charts: {
 *   domain: 'routeDetails' | 'trackEquipments': {
 *     id: {
 *       capabilityName: {
 *         rangeIndex: number
 *       }
 *     }
 *   },
 *  toggles: {...}
 *   domain: 'routeDetails' | 'trackEquipments': {
 *     id: {
 *       positionSource: ['capabilities']
 *     }
 *   }
 * }
 */

function* handleChartFiltersAction(action) {
  const { id, domain, capabilityName, rangeIndex } = action.payload;
  const parsedDetails = yield call(getTelematicsStorageDetails);

  if (
    !Object.values(TELEMETICS_DOMAINS).includes(domain) ||
    !id ||
    !capabilityName ||
    rangeIndex === undefined
  ) {
    return;
  }

  const updatedDetails = {
    ...parsedDetails,
    charts: {
      ...parsedDetails.charts,
      [domain]: {
        ...parsedDetails.charts?.[domain],
        [id]: {
          ...parsedDetails.charts?.[domain]?.[id],
          [capabilityName]: {
            rangeIndex
          }
        }
      }
    }
  };

  yield call(() =>
    localStorage.setItem('telematics', JSON.stringify(updatedDetails))
  );
}

function* handleCloseTab(action) {
  const { key, tag, extra } = action.payload.toJS();
  if (key !== 'TrackEquipmentMapsDisplay' && tag && tag !== 'RouteDetails') {
    return;
  }
  const parsedDetails = yield call(getTelematicsStorageDetails);

  if (key === 'TrackEquipmentMapsDisplay') {
    delete parsedDetails?.charts?.trackEquipments;
    delete parsedDetails?.toggles?.trackEquipments;
  }
  if (tag === 'RouteDetails') {
    const { routeId } = extra;
    delete parsedDetails?.charts?.routeDetails?.[routeId];
    delete parsedDetails?.toggles?.routeDetails?.[routeId];
  }
  yield call(() =>
    localStorage.setItem('telematics', JSON.stringify(parsedDetails))
  );
}

function* handleTelematicsToggle(action) {
  const { id, domain, toggles } = action.payload;
  const parsedDetails = yield call(getTelematicsStorageDetails);

  if (!Object.values(TELEMETICS_DOMAINS).includes(domain) || !id) {
    return;
  }
  const updatedDetails = {
    ...parsedDetails,
    toggles: {
      ...parsedDetails.toggles,
      [domain]: {
        ...parsedDetails.toggles?.[domain],
        [id]: {
          toggles
        }
      }
    }
  };

  yield call(() =>
    localStorage.setItem('telematics', JSON.stringify(updatedDetails))
  );
}

function* watchCloseTab() {
  yield takeEvery(tabs.actions.onClose, handleCloseTab);
}

export function* watchSetTelematicsToggleActions() {
  yield takeEvery(
    telematics.actions.setTelematicsToggle,
    handleTelematicsToggle
  );
}

export function* watchSetTelematicsRangeIndexActions() {
  yield takeEvery(
    telematics.actions.setTelematicsRangeIndex,
    handleChartFiltersAction
  );
}

export default function* () {
  yield all([
    watchSetTelematicsToggleActions(),
    watchSetTelematicsRangeIndexActions(),
    watchCloseTab()
  ]);
}
